
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "Sarah Mitchell",
      location: "Greenwich, CT",
      rating: 5,
      text: "Bath Contractor For You made finding the right contractor so easy! The contractor they matched us with was professional, on time, and did amazing work. Our master bathroom looks incredible!",
      project: "Master Bathroom Remodel",
      image: "https://public.readdy.ai/ai/img_res/3fe83a7bc31af83c8666e6cd93eab0b7.jpg"
    },
    {
      name: "Michael Rodriguez",
      location: "Stamford, CT",
      rating: 5,
      text: "I was skeptical about using a service like this, but their verification process really works. The contractor was licensed, insured, and had an amazing portfolio. Great experience from start to finish.",
      project: "Shower Installation",
      image: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20confident%20Hispanic%20man%20in%20his%2040s%2C%20short%20dark%20hair%2C%20friendly%20smile%2C%20button-down%20shirt%2C%20office%20background%2C%20professional%20lighting&width=80&height=80&seq=testimonial-2&orientation=squarish"
    },
    {
      name: "Jennifer Chen",
      location: "Hartford, CT",
      rating: 5,
      text: "After a bad experience with an unvetted contractor, I was hesitant to renovate again. This service gave me confidence. The contractor exceeded expectations and finished ahead of schedule!",
      project: "Guest Bathroom Renovation",
      image: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20woman%20in%20her%2030s%2C%20long%20black%20hair%2C%20warm%20smile%2C%20professional%20blazer%2C%20modern%20office%20background%2C%20soft%20lighting&width=80&height=80&seq=testimonial-3&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            What Connecticut Homeowners Say
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what Connecticut homeowners say about their experience 
            with our verified contractors.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500"></i>
                ))}
              </div>
              
              <p className="text-gray-700 mb-4 leading-relaxed">
                "{testimonial.text}"
              </p>
              
              <div className="pt-4 border-t border-gray-100">
                <p className="text-sm text-blue-600 font-medium">
                  <i className="ri-home-line mr-1"></i>
                  {testimonial.project}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-4 bg-white rounded-full px-8 py-4 shadow-lg">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-500"></i>
              ))}
            </div>
            <span className="text-gray-600">4.9/5 average rating</span>
            <span className="text-gray-400">•</span>
            <span className="text-gray-600">1,247+ Connecticut reviews</span>
          </div>
        </div>
      </div>
    </section>
  );
}